export const registerListMenuRouter = [{
  path: 'register/list',
  icon: ' iconfont icondengji',
  name: 'registerCount',
  title: '到店登记',
  component: () => import('@/views/gip/register/list.vue')
}]



// WEBPACK FOOTER //
// ./src/router/register/list.js